export {
    AnchorNavigation,
    type AnchorNavigationProps,
} from "./AnchorNavigation";
